// Provenance: repo:tds-reconciliation-portal:frontend/src/components/InfoTip.tsx (ADR-0005)
// — restyled; a click-toggle popover with no dependency (ADR-0010 keeps Mantine out).
import { Info } from 'lucide-react'
import { type ReactNode, useEffect, useRef, useState } from 'react'

/** Instructional prose, folded behind an ⓘ.
 *
 *  The density pass's rule: explanation may hide, STATE that gates work may
 *  not. Every printed how-to paragraph on the dense pages lives here — read
 *  once on day one, it cost a full-width band on day two hundred. Click (not
 *  hover only), so it works on touch and stays up while reading.
 */
export function InfoTip({ children, w = 380 }: { children: ReactNode; w?: number }) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLSpanElement>(null)
  useEffect(() => {
    if (!open) return
    const close = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [open])
  return (
    <span className="relative inline-flex" ref={ref}>
      <button
        type="button"
        className="rounded p-0.5 text-muted-foreground hover:bg-muted"
        aria-label="How this works"
        onClick={() => setOpen((s) => !s)}
      >
        <Info size={16} />
      </button>
      {open && (
        <div
          className="absolute left-0 top-full z-30 mt-1 rounded-md border border-border bg-background p-3 text-xs leading-relaxed text-foreground shadow-lg"
          style={{ width: w }}
        >
          {children}
        </div>
      )}
    </span>
  )
}
